import { fromEvent } from "rxjs";
import { CdpaButtonComponent, CdpaButtonId } from "../../common/components/cdpaButton.component";
import { HTMLElementEventType } from "../../common/components/misc.enums";
import { FormId } from "./common/formId";
import "./login-idp-link-confirm.scss";
export class LoginIdpLinkConfirm {
    constructor() {
        this.form = document.getElementById(FormId.IdpLinkConfirm);
        this.button = new CdpaButtonComponent(CdpaButtonId.ConfirmIdp);
        fromEvent(this.button.buttonElement, HTMLElementEventType.Click).subscribe((event) => {
            this.onClick(event);
        });
    }
    onClick(event) {
        event.preventDefault();
        if (this.button.isLoading) {
            return;
        }
        this.button.isLoading = true;
        this.form.submit();
    }
}
